/**
 * Get the display names of a given user
 *
 * @param  {User} user
 *         The user to get the display name of
 *
 * @return {String} The display name of the given user
 */
export function userName(user) {
  if (!user) {
    return
  }

  const displayName = user.display_name ? ` (${user.display_name})` : ''

  return `${user.username}${displayName}`
}
